export enum StatusCode {
  ACCESS_DENIED = 403,
  NOT_FOUND = 404,
  SERVER_ERROR = 500,
}
